const mutations = {

  GET_PERGUNTAS (state, value) {
    state.AllPerguntas =  value
  },
  ALL_PERGUNTAS (state, value) {
    state.allPerguntas =  value
  },
  SET_AVALIACAO (state, value) {
    state.setAvaliacao =  value
  },

  ALL_CURSOS (state, value) {
    state.cursos = value
  },
  GET_AVALIACOES (state, value) {
    state.allAvaliacoes = value
  },
  GET_AVALIACOES_REALIZADAS (state, value) {
    state.getAvaliacoesRealizadas = value
  },
  GET_OFERTA_PERGUNTAS (state, value) {
    state.allOfertaPerguntas =  value
  },
  GET_PERGUNTA (state, value) {
    state.getPergunta =  value
  }
}

export default mutations
